import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import ModalExample from "../_modal.example.js";
import Modal from "./../";
export const _frontmatter = {
  "ingress": "Modal er et midtstilt vindu som legger seg over det andre innholdet, med en mørk gjennomsiktig bakgrunn. Komponenten bruker npm-pakken <a href=\"https://www.npmjs.com/package/react-modal\">React-modal</a> og extender props fra den."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <p>{`Når modalen åpnes vil den legge seg over det andre innholdet på siden. Modalen kan lukkes igjen ved å klikke på
lukk-knappen, klikke utenfor modalruten eller ved å trykke "Esc" på tastaturet. Innholdet i modalruten kan
bestemmes helt fritt.`}</p>
    <Example mdxType="Example">
  <ModalExample mdxType="ModalExample" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Knapp onClick={() => this.openModal()}>Klikk for å åpne modal</Knapp>
<Modal
    isOpen={this.state.modalIsOpen}
    onRequestClose={() => this.closeModal()}
    closeButton={true}
    contentLabel="Min modalrute"
>
    <div style={{padding:'2rem 2.5rem'}}>Innhold her</div>
</Modal>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      